import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Suomeksi",
  code: "fi",
  messages: {
    alert: {
      close: "Sulje"
    },
    authForm: {
      hidePassword: "Piilota salasana",
      showPassword: "N\xE4yt\xE4 salasana",
      submit: "Jatka"
    },
    banner: {
      close: "Sulje"
    },
    calendar: {
      nextMonth: "Seuraava kuukausi",
      nextYear: "Seuraava vuosi",
      prevMonth: "Edellinen kuukausi",
      prevYear: "Edellinen vuosi"
    },
    carousel: {
      dots: "Valitse n\xE4ytett\xE4v\xE4 dia",
      goto: "Siirry sivulle {slide}",
      next: "Seuraava",
      prev: "Edellinen"
    },
    chatPrompt: {
      placeholder: "Kirjoita viestisi t\xE4h\xE4n..."
    },
    chatPromptSubmit: {
      label: "L\xE4het\xE4"
    },
    colorMode: {
      dark: "Tumma",
      light: "Vaalea",
      switchToDark: "Vaihda tummaan tilaan",
      switchToLight: "Vaihda vaaleaan tilaan",
      system: "J\xE4rjestelm\xE4"
    },
    commandPalette: {
      back: "Takaisin",
      close: "Sulje",
      noData: "Ei tietoja",
      noMatch: "Ei vastaavia tietoja",
      placeholder: "Kirjoita komento tai hae..."
    },
    contentSearch: {
      links: "Linkit",
      theme: "Teema"
    },
    contentSearchButton: {
      label: "Hae..."
    },
    contentToc: {
      title: "T\xE4ll\xE4 sivulla"
    },
    dashboardSearch: {
      theme: "Teema"
    },
    dashboardSearchButton: {
      label: "Hae..."
    },
    dashboardSidebarCollapse: {
      collapse: "Supista sivupalkki",
      expand: "Laajenna sivupalkki"
    },
    dashboardSidebarToggle: {
      close: "Sulje sivupalkki",
      open: "Avaa sivupalkki"
    },
    error: {
      clear: "Takaisin etusivulle"
    },
    fileUpload: {
      removeFile: "Poista {filename}"
    },
    header: {
      close: "Sulje valikko",
      open: "Avaa valikko"
    },
    inputMenu: {
      create: 'Luo "{label}"',
      noData: "Ei tietoja",
      noMatch: "Ei vastaavia tietoja"
    },
    inputNumber: {
      decrement: "V\xE4henn\xE4",
      increment: "Kasvata"
    },
    modal: {
      close: "Sulje"
    },
    pricingTable: {
      caption: "Hinnoitellut suunnitelmat"
    },
    prose: {
      codeCollapse: {
        closeText: "Supista",
        name: "koodi",
        openText: "Laajenna"
      },
      collapsible: {
        closeText: "Piilota",
        name: "ominaisuudet",
        openText: "N\xE4yt\xE4"
      },
      pre: {
        copy: "Kopioi koodi leikep\xF6yd\xE4lle"
      }
    },
    selectMenu: {
      create: 'Luo "{label}"',
      noData: "Ei tietoja",
      noMatch: "Ei vastaavia tietoja",
      search: "Hae..."
    },
    slideover: {
      close: "Sulje"
    },
    table: {
      noData: "Ei tietoja"
    },
    toast: {
      close: "Sulje"
    }
  }
});
